import type { LogFn } from "pino";

import { initLogging } from "@expert/logging";
import { getFullStoryUrlSync } from "@expert/monitoring";

import { isForwardedStreamsEntry, STREAMS_SOURCE } from "@/amazon-connect/streamsLogging";
import { env } from "@/config";

function sendRuntimeErrorMetric([mergeObject]: Parameters<LogFn>): void {
    const dimensions = isForwardedStreamsEntry(mergeObject) ? { source: STREAMS_SOURCE } : undefined;

    // Lazy import: sendMetrics calls getLogger at module load, which requires initLogging first.
    void import("@expert/cloudwatch-metrics").then(({ sendEventMetric }) => {
        void sendEventMetric("RuntimeErrorLogged", dimensions);
    });
}

initLogging({
    appName: env.appName,
    commitHash: env.commitHash,
    logLevel: env.logLevel,
    channel: env.channel,
    isConsoleLogEnabled: !env.disableConsoleLogs,
    mixin: () => ({ fullStoryUrl: getFullStoryUrlSync() ?? "not defined" }),
    onError: sendRuntimeErrorMetric,
});
